import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import services from 'src/services/risk-assessment-key.service';
import { IRiskAssessmentKeySchema } from 'src/models/risk-assessment-key.model';

export const actionTypes = {
  RISK_ASSESSMENT_KEY_FETCH: 'RISK_ASSESSMENT_KEY_FETCH',
  RISK_ASSESSMENT_KEY_DEFAULT: 'RISK_ASSESSMENT_KEY_DEFAULT',
} as const;

export const asyncActions = {
  defaultGET: {
    type: actionTypes.RISK_ASSESSMENT_KEY_DEFAULT,
    service: services.listGET,
  },
  listGET: {
    type: actionTypes.RISK_ASSESSMENT_KEY_FETCH,
    service: services.listGET,
  },
};

export type IRiskAssessmentKeyAsync = typeof asyncActions;

export interface IRiskAssessmentKeyState
  extends ICommonState<IRiskAssessmentKeyAsync> {
  list: IRiskAssessmentKeySchema[];
}

export const defaultState: IRiskAssessmentKeyState = {
  status: {},
  list: [],
};

const RiskAssessmentKeyReducer = (
  state: IRiskAssessmentKeyState = defaultState,
  action: IReducerAction<IRiskAssessmentKeyAsync>
): IRiskAssessmentKeyState => {
  switch (action.type) {
    case actionTypes.RISK_ASSESSMENT_KEY_FETCH: {
      return {
        ...state,
        list: action.payload?.riskAssessmentKey ?? [],
      };
    }

    default: {
      return state;
    }
  }
};

export default RiskAssessmentKeyReducer;
